import { Injectable } from '@angular/core';
import { FrontendApiUpdateLogoutFlowRequest } from '@ory/client';
import { Observable } from 'rxjs';
import { OryCreateInput, OryCreateOutput } from '../../model';
import { OryKratosBaseFlow } from './base.flow';

/**
 * Implements Ory Kratos logout flow for terminating user sessions.
 *
 * @remarks
 * Logout is handled via explicit methods, not generic CRUD:
 * - No UI (no form nodes or messages)
 * - No GET operation (tokens are ephemeral)
 * - Execute takes no input (just the token from the flow)
 *
 * Use via OryService.logout(), createLogout(), or executeLogout().
 */
@Injectable({
  providedIn: 'root'
})
export class OryLogoutFlow extends OryKratosBaseFlow {
  
  /**
   * Creates a logout flow to obtain logout token.
   * @internal Used by OryService.createLogout()
   */
  create(input: OryCreateInput<'logout'> = {}): Observable<OryCreateOutput<'logout'>> {
    return this.fromOryRequest(this.iamApi.createBrowserLogoutFlow(input));
  }

  /**
   * Executes logout using the token from the flow.
   * @internal Used by OryService.executeLogout()
   */
  execute(flow: OryCreateOutput<'logout'>): Observable<void> {
    const apiRequest: FrontendApiUpdateLogoutFlowRequest = {
      token: flow.logout_token,
    };
    return this.fromOryRequest(this.iamApi.updateLogoutFlow(apiRequest));
  }
}
